import request from '@/utils/request'
import type * as Ts from '@/typings/ts'
import type * as Pipeline from '@/typings/pipeline'
import type * as projectType from '@/typings/project'

interface IUpdateTsParams {
  memo_id: number
  ts_summary: Ts.TsSummaryType[]
  ts_summary_remark: string
  ts_files: string[]
}

// Memo详情 - 编辑TS
export async function updateTs(params: IUpdateTsParams) {
  return request('/api/v2/project/pipeline/ts/update', {
    method: 'post',
    data: params
  })
}

interface IUpdateEtsParams {
  memo_id: number
  es_files: string[]
}
// Memo详情 - Ts区 - 更新ETS
export async function updateEts(params: IUpdateEtsParams) {
  return request('/api/v2/project/pipeline/ts/update_empty_ts', {
    method: 'post',
    data: params
  })
}

interface IDeleteTsParams {
  memo_id: number
}
// Memo详情 - Ts区 - 撤回Cornfirm
export async function deleteTs(params: IDeleteTsParams) {
  return request('/api/v2/project/pipeline/ts/delete', {
    method: 'post',
    data: params
  })
}

interface IOpenTsParams {
  memo_id: number
}
// Memo详情 - 开启TS
export async function openTs(params: IOpenTsParams) {
  return request('/api/v2/project/pipeline/ts/open', {
    method: 'post',
    data: params
  })
}

interface ISubmitPmConfirmParams {
  memo_id: number
  project_id: number
}
// Memo详情 - Ts区 - 提交Pm Confirm
export async function submitPmConfirm(params: ISubmitPmConfirmParams) {
  return request('/api/v2/project/pipeline/ts/submit_pm_confirm', {
    method: 'post',
    data: params
  })
}

interface ISubmitLegalConfirmParams {
  memo_id: number
  project_id: number
  status: number
  remark: string
}
// Memo详情 - Ts区 - 提交法务 Confirm
export async function submitLegalConfirm(params: ISubmitLegalConfirmParams) {
  return request('/api/v2/project/pipeline/ts/submit_legal_confirm', {
    method: 'post',
    data: params
  })
}

interface ISubmitTsConfirmParams {
  memo_id: number
  project_id: number
}
// Memo详情 - Ts区 - 提交TS Confirm
export async function submitTsConfirm(params: ISubmitTsConfirmParams) {
  return request('/api/v2/project/pipeline/ts/submit_ts_confirm', {
    method: 'post',
    data: params
  })
}

interface ITsRollbackParams {
  memo_id: number
  project_id: number
}
// Memo详情 - Ts区 - 撤回Cornfirm
export async function tsRollback(params: ITsRollbackParams) {
  return request('/api/v2/project/pipeline/ts/cfo_rollback_confirm', {
    method: 'post',
    data: params
  })
}

interface IEnterTsParams {
  ts: Pipeline.PipelineBaseInfoType
}
// 进入TS（状态）
export async function enterTs(params: IEnterTsParams) {
  return request('/api/v2/project/pipeline/ts/enter', {
    method: 'post',
    data: params
  })
}

// Ts项目列表（常规）
export async function getTsProjectList(params: projectType.MemoSearchParams) {
  return request('/api/v2/project/pipeline/my_search', {
    method: 'POST',
    data: params
  })
}

// TS项目列表（卡片）
export async function getTsCardProjectList(params: projectType.MemoSearchParams) {
  return request('/api/v2/project/pipeline/my_card_search', {
    method: 'POST',
    data: params
  })
}
